import React from 'react'
import styled from 'styled-components'

import Icon from 'components/Icon'
import theme from 'vars/theme'

const Outer = styled.span`
  display: flex;
  position: relative;
  height: 30px;

  & input {
    position: absolute;
    display: block;
    top: 0;
    left: 0;
    opacity: 0;
    width: 200px;
    height: 30px;
    z-index: 1;
  }

  & input:checked ~ .checked {
    display: block;
  }

  & input:checked ~ .not-checked {
    display: none;
  }

  & .check-icon {
    position: absolute;
    top: 2px;
    left: 0;
    border-radius: 4px;
    width: 30px;
    height: 30px;
    border-color: ${theme.grayMedium3};

    img {
      width: 24px;
      height: 24px;
      margin-top: -5px;
    }
  }

  & .checked {
    display: none;
    background-color: ${theme.blueMedium5};
  }

  & .not-checked {
    border-width: 2px;
    border-style: solid;
    background-color: white;
  }

  & .label {
    color: ${theme.darkGrayPrimary};
    font-size: 20px;
    margin-left: 42px;
  }
`

const CheckboxSp = ({ label, checked, disabled = false, isGray = true, className = '', onChange, ...props }) => {

  const handleChange = (evt) => {
    if (!disabled) {
      const { checked } = evt.target
      onChange(checked)
    }
  }

  return (
    <Outer
      className={className}
      style={{ width: label ? undefined : 32, opacity: disabled && !isGray ? 0.4 : 1.0 }}
      {...props}
    >
      <input
        id={props.id}
        data-dg-id={props.id ? `sp-form-input-${props.id}` : undefined}
        type="checkbox"
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
        style={{ cursor: disabled ? 'default' : 'pointer' }}
      />
      <span
        className="check-icon checked text-center"
        style={{ backgroundColor: isGray ? theme.grayMedium3 : theme.blueMedium5 }}
      >
        <Icon src="/assets/svgs/icon-select-white.svg"/>
      </span>
      <span className="check-icon not-checked" style={{ borderColor: isGray ? theme.grayMedium3 : theme.blueMedium5 }} />
      {label && (
        <span className="label">
          {label}
        </span>
      )}
    </Outer>
  )
}

export default CheckboxSp
